module.exports = __webpack_public_path__ + "static/media/DSC04982.9ad40dfb.JPG";